module.exports = __webpack_public_path__ + "img/18-3.ceae84e3.png";